 var AlertMessage = React.createClass({
  propTypes: {
    alertType: React.PropTypes.oneOf(["success", "info", "warning", "danger"]),
    showDismiss: React.PropTypes.bool,
    onDismiss: React.PropTypes.func
  },
  getDefaultProps() {
    return {
      alertType: "warning",
      showDismiss: false,
      onDismiss: function() {}
    }
  },
  render() {
    let dismiss;
    if (this.props.showDismiss) {
      dismiss = <button type="button" className="close" data-dismiss="alert" onClick={this.props.onDismiss}><span aria-hidden="true">&times;</span></button>;
    }

    return (
      <div className={"alert alert-" + this.props.alertType}>
        {dismiss}
        {this.props.children}
      </div>
    )
  }
})

